class statusUpdatesModal {
    constructor($scope, $uibModalInstance, items1) {
        $scope = $.extend($scope, items1)
        // '专用发票'税局'1',     '2'
        // '普通发票'税局'2',     '0'
        // '机动车发票'税局'3',   '12'
        // '电子普通发票'税局'5'  '51'
        // '电子专用发票'税局'6'  '52'
        // '二手车'税局'7'        '15'
        const taxInvType = { 0: '2', 2: '1', 12: '3', 15: '7', 51: '5', 52: '6' }
        /**
         * 格式化日期，不在Dateprototype上加方法
         */
        function getFormatedDate(date) {
            const year = date.getFullYear()
            let month = date.getMonth() + 1
            month = month < 10 ? `0${month}` : `${month}`
            let dateStr = date.getDate()
            dateStr = dateStr < 10 ? `0${dateStr}` : `${dateStr}`
            return `${year}-${month}-${dateStr}`
        }
        $scope.updates = {
            updateDateStart: getFormatedDate(new Date(new Date().setDate(new Date().getDate() - 3))),
            updateDateEnd: getFormatedDate(new Date()),
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function ok() {
            // 返回数据
            $uibModalInstance.close(updatesDataParam())
        }
        const updatesDataParam = () => {
            const { updateDateStart, updateDateEnd } = $scope.updates
            let params = items1.map((el) => {
                return {
                    applyRecordId: el.applyRecordId,
                    applyStateQueryVO: {
                        endTime: updateDateEnd.replace(/-/g, ''),
                        invoiceCategory: taxInvType[el.invoiceType], //票种对应税局票种值
                        startTime: updateDateStart.replace(/-/g, ''),
                        taxNo: el.taxCode,
                    },
                    invStockId: el.isuuid,
                }
            })
            return params
        }
    }
}

statusUpdatesModal.$inject = ['$scope', '$uibModalInstance', 'items1']
export default statusUpdatesModal



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/statusUpdatesModal.js